// The translation endpoints answer per language code ( nl, en, fr ... ), Dutch first.
// The language fields of the menu use their own keys: "all" is the standard field, and a few have a name as key
const apiCodeToFieldKey: Record<string, string> = {
  fr: "french",
  es: "spanish",
};

export type MenuTranslationResponse = Record<string, string>;

// Only the languages of the franchise are kept, the standard field gets the Dutch text
export const toLanguageFields = (
  translations: MenuTranslationResponse | undefined,
  fieldKeys: string[]
): Record<string, string> => {
  const fields: Record<string, string> = {};
  Object.entries(translations ?? {}).forEach(([code, text]) => {
    const key = apiCodeToFieldKey[code] ?? code;
    if (text && fieldKeys.includes(key)) fields[key] = text;
  });
  if (translations?.nl && fieldKeys.includes("all")) {
    fields.all = translations.nl;
  }
  return fields;
};
